var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('files-list',{attrs:{"files":_vm.files,"readonly":!_vm.assetType.id},on:{"upload":function($event){return _vm.upload($event)},"remove":function($event){return _vm.remove($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }